// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Plate$BwaxAdmin = require("../../../../bwax-js/ml/plate.bs.js");
var Lang_eval$BwaxAdmin = require("../../../../bwax-js/ml/lang/lang_eval.bs.js");
var Caml_chrome_debugger = require("bs-platform/lib/js/caml_chrome_debugger.js");
var Lang_mod_json$BwaxAdmin = require("../../../../bwax-js/ml/lang/mod/builtin/lang_mod_json.bs.js");
var Defs_aggregate$BwaxAdmin = require("../../../../bwax-js/ml/query/defs_aggregate.bs.js");
var Runtime_common$BwaxAdmin = require("../../../../bwax-js/ml/lang/mod/runtime_common.bs.js");

var module_name = "AdminChart";

var src = "\n\nmodule " + (String(module_name) + ";\n\nimport AdminPage exposing (Widget);\n\n-- 只要是用于日期、离散数字类型的 axis 的补充，默认只填充空隙\ntype alias AutoFill = \n  { tillNow: Bool -- 只用于日期，默认为 False\n  , sinceDate: Date -- 只用于日期类\n  , tillDate: Date -- 只用于日期类\n\n  , count: Int -- 填充到至少这么多值（实际显示的也不会超过这个数）\n\n  -- , gaps: Bool -- 这个可能不需要了，因为填充肯定是表示填充空隙的。\n  };\n\ntype alias CardConfig = \n  { color: Float -> Color\n  , format: Float -> String -- 还是直接给出一个 numeral 的 format pattern 好了？ \n  , labelColor: Color\n\n  -- 指向 aggregate 和 grouping 中定义的别名\n  , fields: { value: String !, desc: String } !\n\n  , title: String\n  }\n;\n--- the charts \ncard: AggregateConfig a -> ~ CardConfig -> Widget msg = external;\n\n\ntype ScalerType = Linear | Log; \n\ntype XAxisConfig = \n  | Continuous ~ { scaleType: ScalerType, start: Float, end: Float  }\n  | Categorical ~ { miniumCategoryWidth: Int, innerPadding: Float };\n\n-- type HorizontalPosition = Left | Right;\n\ntype alias YAxisConfig = \n  { scaleType: ScalerType, start: Float, end: Float \n  -- , position: HorizontalPosition\n  }\n;\n\ntype alias BarConfig = \n  { xAxis: XAxisConfig\n  , yAxis: ~ YAxisConfig\n  , dataColor: Maybe String -> Float -> Color \n        --- by legend, if there\'s no legend, the given first will be Nothing\n        --- if this function is not provided, the system will use a default color set.\n        --- I think it better to use default color set.\n  , dataFormat: Float -> String \n  , colorScheme: String\n\n  -- 指向 aggregate 和 grouping 中定义的别名\n  , fields: { axis: String, value: String !, legend: String, desc: String } !\n\n  , title: String\n  , autoFill: AutoFill\n  }\n;\n\nbar: AggregateConfig a -> ~ BarConfig -> Widget msg = external;\n\ntype alias LineConfig = \n  { xAxis: XAxisConfig\n  , yAxis: ~ YAxisConfig\n  , dataColor: Maybe String -> Float -> Color \n        --- by legend, if there\'s no legend, the given first will be Nothing\n        --- if this function is not provided, the system will use a default color set.\n        --- I think it better to use default color set.\n  , dataFormat: Float -> String\n  , colorScheme: String \n\n  -- 指向 aggregate 和 grouping 中定义的别名\n  , fields: { axis: String, value: String !, legend: String, desc: String } !\n\n  , title: String\n  , autoFill: AutoFill\n  , atMost: Int -- 图表汇总最多显示多少数量\n  }\n;\n\n\n-- 给定一个 aggregate config，\nline: AggregateConfig a -> ~ LineConfig -> Widget msg = external;\n\ntype alias PieConfig = \n  { dataColor: Maybe String -> Float -> Color \n        --- by legend, if there\'s no legend, the given first will be Nothing\n        --- if this function is not provided, the system will use a default color set.\n        --- I think it better to use default color set.\n  , dataFormat: Float -> String\n  , innerRadius: Float\n\n  , colorScheme: String\n\n  , fields: { legend: String, value: String !, desc: String } !\n\n  , title: String\n  }\n;\n\n-- 给定一个 aggregate config，\n-- 里面应该有一个别名为 legend 的 grouping \n--        和一个别名为 value 的 aggregate\npie: AggregateConfig a -> ~ PieConfig -> Widget msg = external;\n\n\n-- 给定一个 aggregate config ,\n-- 里面应该有一个别名为 axis 的 grouping,\n--          一个别名为 lineValue 的 aggregate\n--          一个别名为 barValue 的 aggregate\n--          (如果按照 PowerBI 的设计，还可能有一个别名为 barLegend 的 grouping \n--           但这不是影响到了 lineValue 的 aggregate 了吗？所以我觉得还是不要 barLegend了\n--           况且有折线再加上 stacked bars 好像信息略显太多了。)\n-- lineAndBar: AggregateConfig a -> pieConfig -> Widget msg = external; \n\n");

function fail(name) {
  throw [
        Lang_eval$BwaxAdmin.Eval_exn,
        module_name + ("." + (name + ": Invalid Arguments"))
      ];
}

function pack_chart_func(name) {
  return /* tuple */[
          name,
          Runtime_common$BwaxAdmin.pack_func(2, (function (param) {
                  if (param) {
                    var match = param[0][0];
                    if (typeof match === "number" || match.tag) {
                      return fail(name);
                    } else {
                      var match$1 = match[0];
                      if (match$1) {
                        var match$2 = match$1[0][0];
                        if (typeof match$2 === "number" || match$2.tag !== /* V_literal */5) {
                          return fail(name);
                        } else {
                          var match$3 = match$2[0];
                          if (typeof match$3 === "number" || match$3.tag !== /* String */2) {
                            return fail(name);
                          } else {
                            var match$4 = match$1[1];
                            if (match$4) {
                              var match$5 = match$4[0][0];
                              if (typeof match$5 === "number" || !(match$5.tag === /* V_record */2 && !match$4[1])) {
                                return fail(name);
                              } else {
                                var match$6 = param[1];
                                if (match$6 && !match$6[1]) {
                                  var match$7 = Defs_aggregate$BwaxAdmin.to_aggregate_params(match$5[0]);
                                  var aggregate_config_000 = match$3[0];
                                  var aggregate_config_001 = /* tuple */[
                                    match$7[0],
                                    match$7[1],
                                    match$7[2],
                                    match$7[3],
                                    match$7[4],
                                    match$7[5],
                                    match$7[6]
                                  ];
                                  var aggregate_config = /* tuple */[
                                    aggregate_config_000,
                                    aggregate_config_001
                                  ];
                                  var config_js = Plate$BwaxAdmin.$$Option.with_default(null, Lang_mod_json$BwaxAdmin.any_value_to_json(/* record */Caml_chrome_debugger.record([
                                              "keeping_native",
                                              "nothing_to_null",
                                              "processors"
                                            ], [
                                              true,
                                              true,
                                              0
                                            ]), match$6[0]));
                                  return Runtime_common$BwaxAdmin.pack_raw(/* Chart */Caml_chrome_debugger.variant("Chart", 6, [
                                                name,
                                                aggregate_config,
                                                config_js
                                              ]));
                                } else {
                                  return fail(name);
                                }
                              }
                            } else {
                              return fail(name);
                            }
                          }
                        }
                      } else {
                        return fail(name);
                      }
                    }
                  } else {
                    return fail(name);
                  }
                }))
        ];
}

var externals_vals = Plate$BwaxAdmin.List.map(pack_chart_func, /* :: */Caml_chrome_debugger.simpleVariant("::", [
        "card",
        /* :: */Caml_chrome_debugger.simpleVariant("::", [
            "bar",
            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                "line",
                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                    "pie",
                    /* [] */0
                  ])
              ])
          ])
      ]));

var externals_000 = module_name;

var externals = /* tuple */[
  externals_000,
  externals_vals
];

var command_handlers = /* [] */0;

exports.module_name = module_name;
exports.src = src;
exports.fail = fail;
exports.pack_chart_func = pack_chart_func;
exports.externals_vals = externals_vals;
exports.command_handlers = command_handlers;
exports.externals = externals;
/* src Not a pure module */
